import { CausationNode, IndexedCausationNode, indexedCausationNodeToCausationNode } from "../Causation/CausationNode";
import { observable, action } from "mobx";

export class CausationGraphObserver {

	// Important to use deep = false, lest modifications by indexedCausationNodeToCausationNode are lost
	causationNodesByCausationNodeIndex = observable.map<number, CausationNode>(undefined, {deep: false});
	causationNodesByEventIndex = observable.map<number, CausationNode>(undefined, {deep: false});

	integrateUpdates = action ( (newIndexedCausationNodes: IndexedCausationNode[]) => {
		const toNode = indexedCausationNodeToCausationNode(this.causationNodesByCausationNodeIndex);
		// ProcessInfo.log(`Reconstituting ${newIndexedCausationNodes.length} causation nodes`);
		for (const newIndexedCausationNode of newIndexedCausationNodes) {
			const newCausationNode = toNode(newIndexedCausationNode);
			if ('eventIndex' in newCausationNode) {
				this.causationNodesByEventIndex.set(newCausationNode.eventIndex, newCausationNode);
			}
		}
	} );

	getCauseOfEventIndex = (eventIndex: number) => {
		return this.causationNodesByEventIndex.get(eventIndex);
	};

}
